import type { FaireProductEntity } from "../../entity_types/product";

export const p_dve6dft3ai: FaireProductEntity = {
  token: "p_dve6dft3ai",
  type: "product",
  name: "Moroccan Cone Glassware Small - Amber",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/e62cde994aa5b184c404f8c44700fdda0ab226b4f9af53dee7f3b4520eda324b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ef4d90610ee3b094a7c6fc4a23649d3e92d1d95b1b6f2324be979eb2af215a14.jpeg",
    "https://cdn.faire.com/fastly/2d66189a60ea17e1ddd369abaca7a75ce14ba02af1dce849890d01e56da347ff.jpeg",
    "https://cdn.faire.com/fastly/7a8b2ef96f44659891ed8bb21bc9c5a8e433f5ba620148fd1eee29fc15a3a706.jpeg",
    "https://cdn.faire.com/fastly/a6db4a9fbbd6509edad31830efbc85885f9ccedb1c5212139fba2264cba2d1d8.jpeg",
    "https://cdn.faire.com/fastly/84c22145cc75956a05179ff15283753c226e0c82bfbdeeae04480afea1c02438.jpeg",
    "https://cdn.faire.com/fastly/081b0cf29fe02d3bf96586d87274d78e40c746c560c4d72d6e42554cbe15aa13.jpeg",
    "https://cdn.faire.com/fastly/1059779fff0ecd118c99f1db509a7e432723883a5dd21348ab7f8b0b60449305.jpeg",
    "https://cdn.faire.com/fastly/a34b8b95f0a48e73301dbffdc785a329a63d496ae475559651afd8e886fcadbc.jpeg",
    "https://cdn.faire.com/fastly/8eadbcbaf75ea0a9147cc380129ffd099126b319dcf76f54a028893de2a1fe91.jpeg",
  ],
  priceDollars: 3.75,
  description:
    "**Packaged in sets of 6 - 24 single glasses in a master\n\nOur Moroccan glassware is made from recycled wine bottles, beer bottles, jars, or other glass containers. Slight variations in hue/color can arise due to variations in temperature, the amount of glass used, or even the artistic choices made during production. These differences contribute to the unique charm and individual character of each piece.\n\nThe sleek and simple design of these hand-blown cone-shaped glasses is a testament to the style and skill of the artisans who make them. Used for all types of beverages or as little vases to decorate each table setting, you will enjoy the feel of them in your hand as you toast the joys of the day. \n\nOur Moroccan glassware sets come in four distinct shades of transparent glass (Clear, Amber, Blue & Green). The handblown construction is evident in the bubbles suspended in the glass itself, and the organic forms that the vessels take.\n\nCapacity: 8 fl oz",
  tags: [],
  msrpDollars: 7.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:52.171Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
